import { Component, Input } from "@angular/core";

@Component({
    selector: "web-spinner",
    templateUrl: "./spinner.component.html",
    styleUrls: ["./spinner.component.scss"],
})
export class SpinnerComponent {
    @Input() size = 20;
    @Input() stroke = 2;
    @Input() color = "";
}
